"use client";

import { Popover as HeroPopover } from "@heroui/react";
import { cn } from "../../lib/utils";

export const Popover = ({ className, ...props }: { className?: string } & React.ComponentProps<typeof HeroPopover>) => {
  return <HeroPopover className={cn(className)} {...props} />;
};
